<era-title>
  <span title
        i18n>Access</span>
</era-title>

@if (aclParents().length > 0) {
  <era-pane>
    <h5 class="small-caps"
        i18n>Parents</h5>
    @for (parent of aclParents(); track parent) {
      <p class="my-0">{{ parent.name }}</p>
    }
  </era-pane>
}

@if (environment.features.security.operations) {
  <era-pane>
    <form [formGroup]="operationsForm">
      @for (operation of operations; track operation) {
        <div>
          <h5 class="small-caps"
              i18n>{{ operation }}</h5>
          <label for="{{ operation }}"
                 class="visually-hidden">{{ operation }}</label>
          <select class="form-select"
                  id="{{ operation }}"
                  formControlName="{{ operation }}">
            <option value="allow">Allow</option>
            <option value="inherit">Not set</option>
            <option value="inheritAllow"
                    disabled>Allow (inherited)</option>
            <option value="inheritDeny"
                    disabled>Deny (inherited)</option>
            <option value="deny">Deny</option>
          </select>
        </div>
      }
    </form>
    <button type="button"
            class="btn btn-primary mt-3"
            (click)="submitForm()">Save Changes</button>
  </era-pane>
}